import { useEffect, useState } from "react";
import { GUEST_RETENTION_DAYS } from "@fiket/booth-schema";
import { useRouter } from "../../store/router";
import { useI18n } from "../../i18n/useI18n";
import { Button } from "../../components/ui/Button";
import { Lines } from "../../components/ui/Lines";
import { ShareQrAside, useShareQrUrl } from "../PrintShare/ShareQrAside";
import { thanksSeconds } from "./thanksTiming";

/**
 * STAGE · Thanks — 카운트다운 후 자동으로 첫 화면.
 * 세션 QR 이 있으면(인쇄·공유 뒤, BOOTH-63) QR 을 마지막으로 한 번 더 보여주고 더 오래(30초) 기다린다 — 이때는
 * 화면 전체 터치 리셋을 끈다(QR 을 찍으려 화면에 손이 닿으면 어트랙트로 튀어 버림). 대신 "처음으로" 버튼.
 * QR 이 없으면(예외 경로) 기존대로 6초 + 아무 데나 터치.
 */
export function ThanksView() {
  const reset = useRouter((s) => s.resetSession);
  const { t } = useI18n();
  const hasQr = useShareQrUrl() !== null;
  const seconds = thanksSeconds(hasQr);
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    setRemaining(seconds);
    let n = seconds - 1;
    const id = setInterval(() => {
      setRemaining(n);
      if (n <= 0) {
        clearInterval(id);
        reset();
      }
      n -= 1;
    }, 1000);
    return () => clearInterval(id);
  }, [reset, seconds]);

  // 워드마크는 헤더에 이미 있다 — 본문 중복 제거 (2026-10-21)
  const body = (
    <>
      <h1 className="thanks__title">{t.thanks.title}</h1>
      <p>{t.thanks.body(remaining)}</p>
    </>
  );

  if (!hasQr) {
    return (
      <button type="button" className="view center" onClick={reset} style={{ width: "100%" }}>
        {body}
        <span className="note" style={{ marginTop: 40 }}>{t.thanks.tapHint}</span>
      </button>
    );
  }

  return (
    <div className="view view--thanks">
      <div className="view__body center thanks">
        {body}
        <div className="thanks__qr">
          <ShareQrAside />
          <h2>{t.printShare.qrHeading}</h2>
          <p><Lines text={`${t.printShare.desc1}\n${t.printShare.desc2(GUEST_RETENTION_DAYS)}`} /></p>
        </div>
      </div>
      <div className="view__sub">
        <Button variant="secondary" sm onClick={reset}>{t.printShare.home}</Button>
      </div>
    </div>
  );
}
